
import Vue from 'vue';
import { mapState } from 'vuex';
import Modal from '@/components/common/Modal/Modal.vue';
import CloseIcon from '@/assets/svg/close.vue.svg';
import { groupBy } from '@/components/utils/core/collection';
import type { IPostTopic } from '@/types/community';
import WarRoomTopic from '@/components/partials/war-room/WarRoomTopic/WarRoomTopic.vue';
import { modalNames } from '~/components/partials/war-room/constants';
import { SUGGESTED_CATEGORY_TITLE } from '~/components/partials/war-room/WarRoomPostForm/WarRoomPostFormCategories/constants';
import { omit } from '~/components/utils/core/object';

interface IData {
  modalName: string;
}

export default Vue.extend({
  name: 'WarRoomTopicsListModal',
  components: {
    CloseIcon,
    Modal,
    WarRoomTopic,
  },
  data(): IData {
    return {
      modalName: modalNames.TOPICS_LIST,
    };
  },
  computed: {
    ...mapState('warRoom', ['topics_with_posts']),
    topicsByCategory(): Record<string, Array<IPostTopic>> {
      return groupBy(this.topics_with_posts, 'category');
    },
    topicsByCategoryWithoutSuggested(): Record<string, IPostTopic[]> {
      return omit(this.topicsByCategory, [SUGGESTED_CATEGORY_TITLE]);
    },
    topicsSuggestedByMembers(): IPostTopic[] {
      return this.topicsByCategory[SUGGESTED_CATEGORY_TITLE];
    },
  },
  methods: {
    handleClose(): void {
      this.$modal.hide(this.modalName);
    },
  },
});
